import { post } from './client';
import { API_ENDPOINTS } from '../config/api';

interface DeleteAccountResponse {
  success?: boolean;
  error?: {
    message?: string;
  };
}

export async function deleteAccount(loginKey: string) {
  return post<DeleteAccountResponse>(API_ENDPOINTS.ACCOUNT_DELETE, { login_key: loginKey });
}

export default {
  deleteAccount,
};
